import request from "../../utils/fetch";

// add data
export const addCompany = (postData) => request.post(`subscription/companies`, postData);

// fetch data
export const loadCompanies = () => request.get(`subscription/companies?sort=-lastModified`);

// delete data
export const deleteCompany = ({ id }) => request.del(`subscription/companies/${id}`);

// edit company
export const editCompany = ({ id }) => request.get(`subscription/companies?_id=${id}`);

// update company
export const updateCompany = (postData) => request.patch(`subscription/companies/${postData.companyId}`, postData);
